import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledChangePasswordNotif = styled('div')(
  () => css`
    .change-Password-Notif {
      &.disabled {
        opacity: 0.5;
      }
      .bullet {
        width: 12px;
        height: 12px;
        background: #4c6fff;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        border-radius: 11px;
      }
      .title {
        color: #777777;
        font-size: 0.75rem;
        text-align: right;
        flex: 1;
        position: relative;
      }
      .date-time {
        color: #777777;
        font-size: 0.625rem;
      }
      .icon {
        margin-right: 0 !important;
      }
      .message {
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 24px;
        text-align: right;
        color: #454545;
        margin-right: 25px;
        margin-bottom: 8px;
      }
    }
  `
);
